import { isRejectedWithValue } from '@reduxjs/toolkit';
import { logout } from '@/features/auth/authSlice';

// Vite injects the deploy-time base path here:
//  - "/"                 en multi-conteneurs (chaque jeu a son propre domaine)
//  - "/jeu-alignement/"  sous le méga-conteneur GAO (préfixe de chemin)
const BASE = import.meta.env.BASE_URL || '/';

/**
 * Extrait la langue réelle du chemin, APRÈS avoir retiré le préfixe de déploiement.
 * Sans ça, sous le méga-conteneur, split('/')[1] capte "jeu-alignement" au lieu de "fr".
 */
const currentLang = () => {
  let path = window.location.pathname;
  if (BASE !== '/' && path.startsWith(BASE)) {
    path = path.slice(BASE.length - 1); // garde le "/" de tête
  }
  const seg = path.split('/').filter(Boolean)[0];
  return seg === 'fr' || seg === 'en' ? seg : 'fr';
};

/**
 * This middleware listens for rejected RTK Query actions.
 * If a 401 Unauthorized error occurs, it logs the user out and redirects to the login page.
 */
export const rtkQueryErrorMiddleware = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    console.warn('API call rejected!', action.payload);

    // Check for 401 Unauthorized error
    if (action.payload.status === 401) {
      // Don't logout if this is a login attempt itself
      const isLoginEndpoint = action.meta?.arg?.endpointName === 'login';

      if (!isLoginEndpoint) {
        const wasAuthenticated = !!api.getState()?.auth?.user;
        api.dispatch(logout());

        if (wasAuthenticated) {
          const lang = currentLang();
          // BASE se termine déjà par "/" → `${BASE}fr/login`
          window.location.href = `${BASE}${lang}/login`;
        }
      }
    }
  }

  return next(action);
};
